import { actions as cmsActions } from 'services/cms-state'
import { GET_PROFILE_FAILURE, GET_PROFILE_SUCCESS, SIGN_OUT_SUCCESS } from '../../app-state/profile/constants'
import { getCurrentViewPort } from '../index'

const { CMS_API_SUCCESS, CMS_API_FILE_NOT_FOUND, CMS_API_FAILURE } = cmsActions

export const setAnalyticsMetadata = (metaData) => {
  const analytics = window.analytics || {}
  window.analytics = { ...analytics, ...metaData }
}

const globalAnalyticsMetaData = () => {
  const viewPort = getCurrentViewPort()
  const isSignedIn = window.analytics && window.analytics.isSignedIn
    ? window.analytics.isSignedIn : false
  return {
    viewPort,
    isSignedIn,
  }
}

export const populateAnalyticsMetadata = (metaData) => {
  const analytics = window.analytics || {}
  window.analytics = { ...analytics, ...metaData, ...globalAnalyticsMetaData() }
}

export const trackSignalEvent = (event, metaData) => {
  // create and dispatch the event
  try {
    const detail = { ...metaData, ...globalAnalyticsMetaData() }
    populateAnalyticsMetadata(metaData)
    const custEvent = new CustomEvent(event, { detail })
    setTimeout(() => window.dispatchEvent(custEvent), 500)
  } catch (error) {
    /* eslint-disable  no-console */
    console.log(`Can't dispatch a custom event because of : ${error}`)
  }
}

const getDocHeight = () => {
  const D = document
  return Math.max(
    D.body.scrollHeight, D.documentElement.scrollHeight,
    D.body.offsetHeight, D.documentElement.offsetHeight,
    D.body.clientHeight, D.documentElement.clientHeight,
  )
}

export const getScrolledDepth = () => {
  const winheight = window.innerHeight || (document.documentElement || document.body).clientHeight
  const docheight = getDocHeight()
  const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
  const trackLength = docheight - winheight
  const pctScrolled = trackLength > 0 ? Math.floor(scrollTop / trackLength * 100) : 0
  return pctScrolled
}

export const triggerScrollDepth =()=>{
     const viewed ={};
     const scrollDepth=getScrolledDepth()
     trackSignalEvent('a_scrollDepth', {scrollDepth})
}

// List of actions whitelisted for analytics.
export const whiteList = [
  CMS_API_SUCCESS,
  CMS_API_FILE_NOT_FOUND,
  CMS_API_FAILURE,
  GET_PROFILE_SUCCESS,
  SIGN_OUT_SUCCESS,
  GET_PROFILE_FAILURE,
]



// WEBPACK FOOTER //
// ./services/utility/analytics/index.js